import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';

// Los mockups son PNG grandes: pedimos una versión reducida y comprimida al CDN
// para aligerar la carga de la página.
function optimizedSrc(url: string, width: number): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}width=${width}&quality=60&format=webp`;
}
export function BonosSection() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-20" aria-labelledby="bonos" data-id="element-21" data-mp="tgj85slteaiu">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-22" data-mp="ofvm7lcg0jvh">
        <div data-id="element-23" data-mp="kejqqz6w14fd">
          <p className="flex items-center gap-2 font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" data-id="element-24" data-mp="kea1jdto31aq">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="fhjkan64lznq" />
            5 Bonos estratégicos
          </p>
          <h2 id="bonos" className="mt-3 max-w-2xl font-display text-3xl font-900 leading-tight text-white sm:text-4xl" data-id="element-26" data-mp="2esb9co772ymy">
            Siempre incluidos — activan el sistema desde el día uno
          </h2>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="vv0qvtqzj2cv">
          {bonos.map(bono => <li key={bono.number} className="flex flex-col rounded-xl border border-ink-800 bg-ink-950 p-6" data-id="element-28" data-mp="hvhufy7jdfge">
              <span className="font-display text-3xl font-900 leading-none text-ink-600" data-id="element-29" data-mp="mvx6mmg30gws">
                {bono.number}
              </span>
              {bono.image && <img src={optimizedSrc(bono.image, 320)} srcSet={`${optimizedSrc(bono.image, 220)} 220w, ${optimizedSrc(bono.image, 320)} 320w`} sizes="(min-width: 1024px) 180px, (min-width: 768px) 200px, 45vw" alt={`Mockup del bono ${bono.number}: ${bono.title}`} className={`mt-4 h-auto rounded-lg bg-white object-contain ${bono.imageSize === 'half' ? 'w-1/2' : 'w-full'}`} width={320} height={320} loading="lazy" decoding="async" data-id="element-30" data-mp="1ekh3hffy2l9n" />}
              <h3 className="mt-4 font-display text-lg font-800 leading-snug text-white" data-id="element-31" data-mp="1y6944qn22kiq">
                {bono.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400" data-id="element-32" data-mp="1t7645klxn4hm">{bono.description}</p>
              <p className="mt-auto flex items-baseline gap-2 pt-5" data-id="element-33" data-mp="1p7neycn2w78z">
                <span className="text-sm text-slate-500 line-through" data-id="element-34" data-mp="1kf41dfoe5c46">{bono.price}</span>
                <span className="font-display text-sm font-800 uppercase tracking-wide text-leaf-400" data-id="element-35" data-mp="1ffrit74jyr7e">
                  Gratis
                </span>
              </p>
            </li>)}

          <li className="flex flex-col justify-center rounded-xl border border-gold bg-ink-800 p-6" data-id="element-36" data-mp="15imt4xbi0dlu">
            <p className="text-xs font-600 uppercase tracking-[0.2em] text-slate-300" data-id="element-37" data-mp="11fzykong0eky">
              Valor total de los 5 bonos
            </p>
            <p className="mt-2 flex flex-wrap items-baseline gap-3" data-id="element-38" data-mp="3d3ljpet5ujt4">
              <span translate="no" className="whitespace-nowrap font-display text-4xl font-900 text-slate-500 line-through" data-id="element-39" data-mp="3h4f8sbica4nl">
                $89&nbsp;USD
              </span>
              <span className="font-display text-4xl font-900 uppercase text-leaf-400" data-id="element-40" data-mp="3r34gjbgiu8q4">Gratis</span>
            </p>
            <p className="mt-3 text-sm leading-relaxed text-slate-200" data-id="element-41" data-mp="2tdszyi0iggcj">
              Incluidos con tu Código Solar 360°
            </p>
          </li>
        </ul>
      </div>
    </section>;
}